import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
interface NewsfilateProHeaderProps {
  onJoinBeta: () => void;
  isSignedUp: boolean;
}
export function NewsfilateProHeader({
  onJoinBeta,
  isSignedUp
}: NewsfilateProHeaderProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full bg-white/90 backdrop-blur-sm border-b border-gray-100" data-id="element-478">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-479">
        <div className="flex items-center justify-between h-16" data-id="element-480">
          <div className="flex items-center" data-id="element-481">
            <a href="#" className="flex-shrink-0" data-id="element-482">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/xckowmcscdatvwqg3ex8v2/3eb2f218-c9ff-4fe6-ad82-ebadfcc155d3/Nf_final.png" alt="Newsfiliate Logo" className="h-8" data-id="element-483" />
            </a>
          </div>

          <div className="flex items-center" data-id="element-484">
            <button onClick={onJoinBeta} className="hidden md:inline-flex items-center px-6 py-2.5 border border-transparent text-sm font-semibold rounded-lg text-white hover:bg-opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#5e60ce] transition-all" style={{
            backgroundColor: '#5e60ce'
          }} data-id="element-485">
              {isSignedUp ? "You're on the list" : 'Join Beta'}
            </button>

            <button className="md:hidden p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#5e60ce]" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-486">
              {isMenuOpen ? <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-487" /> : <MenuIcon className="h-6 w-6" aria-hidden="true" data-id="element-488" />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && <div className="md:hidden py-4 border-t border-gray-100" data-id="element-489">
            <button onClick={() => {
          onJoinBeta();
          setIsMenuOpen(false);
        }} className="w-full inline-flex items-center justify-center px-6 py-3 border border-transparent text-sm font-semibold rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#5e60ce]" style={{
          backgroundColor: '#5e60ce'
        }} data-id="element-490">
              {isSignedUp ? "You're on the list" : 'Join Beta'}
            </button>
          </div>}
      </div>
    </header>;
}